export default __webpack_public_path__ + "static/quotes-02744ec1813d2cb1812c1289506f9f51.svg";